import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import './legal.css';

function TermsOfService() {
  const [showScrollBtn, setShowScrollBtn] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    // Remover el loader inicial
    document.getElementById('initial-loader')?.remove();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollBtn(true);
      } else {
        setShowScrollBtn(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="legal-container">
      <div className="legal-content">
        <div className="legal-header">
          <h1>Términos de Servicio</h1>
          <p className="last-updated">Última actualización: 17 de mayo de 2026</p>
        </div>

        <section className="legal-section">
          <h2>1. Aceptación de Términos</h2>
          <p>
            Al acceder y utilizar Turnlink ("Plataforma"), aceptas estar vinculado por estos Términos de Servicio. 
            Si no aceptas estos términos, no debes usar la Plataforma.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Descripción del Servicio</h2>
          <p>
            Turnlink es una plataforma de gestión de citas que permite a negocios (barbería, peluquería, spa, etc.):
          </p>
          <ul>
            <li>Administrar calendarios y disponibilidad</li>
            <li>Crear y gestionar citas con clientes</li>
            <li>Recibir notificaciones por WhatsApp</li>
            <li>Integrar con Google Calendar</li>
            <li>Analizar ingresos y estadísticas</li>
            <li>Personalizar la experiencia del cliente</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Elegibilidad</h2>
          <p>Para usar Turnlink, debes:</p>
          <ul>
            <li>Tener al menos 18 años</li>
            <li>Tener autoridad legal para representar tu negocio</li>
            <li>No estar prohibido legalmente de usar servicios en línea</li>
            <li>Proporcionar información precisa y actualizada</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Registro y Credenciales</h2>
          <p>
            Eres responsable de:
          </p>
          <ul>
            <li>Crear una contraseña segura</li>
            <li>Mantener la confidencialidad de tus credenciales</li>
            <li>Notificarnos inmediatamente de acceso no autorizado</li>
            <li>Mantener tu información de perfil actualizada</li>
            <li>Todas las actividades realizadas en tu cuenta</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. Uso Permitido</h2>
          <p>
            Aceptas usar la Plataforma solo para:
          </p>
          <ul>
            <li>Gestionar citas de tu negocio legítimo</li>
            <li>Propósitos comerciales legales</li>
            <li>Comunicación con clientes</li>
            <li>Análisis de datos de tu negocio</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Conducta Prohibida</h2>
          <p>
            No debes usar la Plataforma para:
          </p>
          <ul>
            <li>Contenido ilegal o que viole derechos de terceros</li>
            <li>Hacking, acceso no autorizado o interferencia con sistemas</li>
            <li>Spam, acoso, comportamiento abusivo o discriminatorio</li>
            <li>Recopilar datos sin autorización (scraping)</li>
            <li>Crear múltiples cuentas para evasión de reglas</li>
            <li>Malware, virus o código malicioso</li>
            <li>Impersonación o fraude</li>
            <li>Violación de privacidad de clientes</li>
            <li>Actividades ilegales o inmoral</li>
            <li>Revender acceso a la Plataforma</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. Propiedad Intelectual</h2>
          <p>
            <strong>Tu Contenido:</strong> Retienes propiedad de datos y contenido que subes. 
            Nos otorgas licencia para usarlo en la Plataforma.
          </p>
          <p>
            <strong>Nuestro Contenido:</strong> Todo software, diseño, texto, logos y funcionalidad de Turnlink 
            son propiedad de Turnlink. No puedes copiar, modificar ni distribuir sin permiso.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Integraciones de Terceros</h2>
          <h3>Google Calendar:</h3>
          <ul>
            <li>Los datos se procesa según términos de Google</li>
            <li>Retienes control sobre tu calendario de Google</li>
            <li>Puedes revocar acceso en cualquier momento</li>
          </ul>

          <h3>WhatsApp:</h3>
          <ul>
            <li>El servicio se procesa según términos de WhatsApp</li>
            <li>Responsabilidad de consentimiento de clientes para mensajes</li>
            <li>Cumplimiento con leyes de privacidad aplicables</li>
          </ul>

          <p>
            <strong>Nota:</strong> No somos responsables de servicios de terceros. 
            Revisa sus términos y políticas de privacidad.
          </p>
        </section>

        <section className="legal-section">
          <h2>8.1 Aclaración sobre WhatsApp y Tecnología Utilizada</h2>
          <p>
            Turnlink utiliza una librería de código abierto de terceros que permite la integración 
            con WhatsApp para enviar y recibir mensajes de confirmación y recordatorios de citas.
          </p>

          <h3>Importante - Riesgos Potenciales:</h3>
          <ul>
            <li>
              <strong>Riesgo de Suspensión Temporal:</strong> WhatsApp podría suspender o restringir 
              temporalmente números de teléfono que detecte utilizando integraciones no oficiales, 
              aunque este riesgo es mínimo si se usa apropiadamente.
            </li>
            <li>
              <strong>No es un Servicio Oficial:</strong> La integración utilizada no es un producto oficial de WhatsApp. 
              Meta (propietaria de WhatsApp) podría cambiar sus políticas o bloquear esta tecnología 
              sin previo aviso.
            </li>
            <li>
              <strong>Política de Uso:</strong> Nuestro uso se limita exclusivamente a responder 
              mensajes de citas y enviar confirmaciones/recordatorios. NO realizamos campañas masivas, 
              spam ni uso comercial indebido.
            </li>
          </ul>

          <h3>Exención de Responsabilidad:</h3>
          <p>
            <strong>Turnlink NO es responsable de:</strong>
          </p>
          <ul>
            <li>Suspensiones, restricciones o baneos de tu número de WhatsApp por Meta/WhatsApp</li>
            <li>Cambios en políticas de WhatsApp que afecten la funcionalidad</li>
            <li>Indisponibilidad temporal del servicio por cambios en WhatsApp</li>
            <li>Pérdida de mensajes o datos relacionados con la integración</li>
            <li>Cualquier consecuencia derivada del uso de integraciones no oficiales</li>
          </ul>

          <h3>Tu Responsabilidad:</h3>
          <p>
            Al usar la integración de WhatsApp en Turnlink, ACEPTAS Y RECONOCES:
          </p>
          <ul>
            <li>Entiendes que estás utilizando una integración no oficial de WhatsApp</li>
            <li>Asumes todo riesgo de suspensión o restricción de tu cuenta de WhatsApp</li>
            <li>Usarás el servicio únicamente para gestionar citas de tu negocio legítimo</li>
            <li>No realizarás spam, mensajes masivos no solicitados ni uso indebido</li>
            <li>Cumplirás con todas las leyes de privacidad y protección de datos aplicables</li>
            <li>Obtendrás consentimiento expreso de tus clientes antes de enviar mensajes</li>
            <li>No responsabilizarás a Turnlink por acciones de Meta/WhatsApp</li>
          </ul>

          <h3>Recomendaciones:</h3>
          <ul>
            <li>Utiliza un número de teléfono comercial dedicado para WhatsApp, no personal</li>
            <li>Mantén registro de consentimientos de clientes</li>
            <li>Monitorea la salud de tu cuenta de WhatsApp regularmente</li>
            <li>Contacta a soporte si experimentas restricciones en tu número</li>
            <li>Considera usar la API oficial de WhatsApp Business como alternativa futura</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>9. Limitaciones de Responsabilidad</h2>
          <p>
            <strong>Descargo de Garantía:</strong> La Plataforma se proporciona "como está" sin garantías 
            de ningún tipo, expresas o implícitas.
          </p>
          <ul>
            <li>No garantizamos disponibilidad 24/7 sin interrupciones</li>
            <li>No somos responsables de pérdida de datos por tu negligencia</li>
            <li>No garantizamos funcionalidad con sistemas no soportados</li>
            <li>Tu uso es bajo tu propio riesgo</li>
          </ul>

          <h3>Limitación de Daños:</h3>
          <p>
            En ningún caso Turnlink será responsable por daños indirectos, incidentales, especiales o 
            consecuentes derivados del uso de la Plataforma, incluso si hemos sido notificados de su posibilidad.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Responsabilidad de Datos</h2>
          <p>
            Eres responsable de:
          </p>
          <ul>
            <li>Mantener backups de datos importante</li>
            <li>Cumplir con leyes de protección de datos (GDPR, CCPA, etc.)</li>
            <li>Obtener consentimiento de clientes para sus datos</li>
            <li>Privacidad y seguridad de datos de clientes</li>
            <li>Informar sobre cambios políticos a clientes</li>
          </ul>
          <p>
            Turnlink proporciona herramientas pero TÚ eres responsable del cumplimiento legal.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Pago y Facturación</h2>
          <p>
            Si utilizas servicios de pago:
          </p>
          <ul>
            <li>Aceptas pagar según la tarifa vigente</li>
            <li>Aceptas cargos periódicos en tu método de pago</li>
            <li>Tu información de pago es procesada de forma segura</li>
            <li>Cambios de precio se notifican con 30 días de anticipación</li>
            <li>Puedes cancelar en cualquier momento</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>12. Cancelación y Terminación</h2>
          <h3>Por tu parte:</h3>
          <ul>
            <li>Puedes cancelar tu cuenta en cualquier momento</li>
            <li>Se exportarán tus datos en formato estándar</li>
            <li>Algunos datos pueden retenerse según ley (impuestos, fraude)</li>
          </ul>

          <h3>Por nuestra parte:</h3>
          <p>
            Podemos terminar tu acceso si:
          </p>
          <ul>
            <li>Violas estos términos</li>
            <li>Usas la Plataforma para actividades ilegales</li>
            <li>No pagas las cuotas (si aplica)</li>
            <li>Amenaza a la seguridad o integridad de la Plataforma</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>13. Modificación de la Plataforma</h2>
          <p>
            Reservamos el derecho de:
          </p>
          <ul>
            <li>Modificar, mejorar o eliminar funciones</li>
            <li>Realizar mantenimiento (con notificación si es posible)</li>
            <li>Descontinuar la Plataforma (con 60 días de aviso)</li>
            <li>Cambiar precios y planes</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>14. Indemnización</h2>
          <p>
            Aceptas indemnizar y proteger a Turnlink de:
          </p>
          <ul>
            <li>Reclamaciones derivadas de tu uso de la Plataforma</li>
            <li>Violación de estos términos</li>
            <li>Daño a terceros por tus acciones</li>
            <li>Violación de leyes aplicables</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>15. Disputas y Resolución</h2>
          <h3>Período de Consulta:</h3>
          <p>
            Antes de litigio, ambas partes acuerdan intentar resolver disputas mediante comunicación 
            directa en un período de 30 días.
          </p>

          <h3>Mediación:</h3>
          <p>
            Si no se resuelve, ambas partes pueden solicitar mediación antes de proceder legalmente.
          </p>

          <h3>Jurisdicción:</h3>
          <p>
            Estos términos se rigen por las leyes del país donde opera Turnlink. 
            Cualquier litigio se llevará a cabo en los tribunales competentes.
          </p>
        </section>

        <section className="legal-section">
          <h2>16. Políticas de Privacidad</h2>
          <p>
            Tu uso de la Plataforma también se rige por nuestra Política de Privacidad. 
            Revísala en [link a política de privacidad].
          </p>
        </section>

        <section className="legal-section">
          <h2>17. Avisos</h2>
          <p>
            Cualquier aviso legal se puede enviar por:
          </p>
          <ul>
            <li>Correo electrónico: <strong>soporte@turnlink.app</strong></li>
            <li>Por correo postal a nuestra dirección registrada</li>
            <li>Mensaje dentro de la Plataforma</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>18. Integridad del Acuerdo</h2>
          <p>
            Si alguna disposición de estos términos es inválida, las demás permanecen vigentes. 
            Si alguna cláusula no se aplica, no constituye renuncia de otros derechos.
          </p>
        </section>

        <section className="legal-section">
          <h2>19. Cambios en Términos</h2>
          <p>
            Podemos actualizar estos términos ocasionalmente. Te notificaremos cambios significativos 
            por correo o mediante aviso en la Plataforma. Tu uso continuado implica aceptación.
          </p>
        </section>

        <section className="legal-section">
          <h2>20. Contacto</h2>
          <p>
            Si tienes preguntas sobre estos términos:
          </p>
          <ul>
            <li>Email: <strong>soporte@turnlink.app</strong></li>
            <li>Sitio: <strong>www.turnlink.app</strong></li>
          </ul>
        </section>
      </div>

      <button 
        className={`scroll-to-top-btn ${showScrollBtn ? 'show' : ''}`}
        onClick={scrollToTop}
        title="Volver al inicio"
        style={{ display: showScrollBtn ? 'flex' : 'none' }}
      >
        <ChevronUp size={24} />
      </button>
    </div>
  );
}

export default TermsOfService;
